import { useEffect, useRef } from "react";
import { useDrag } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import { Playlist } from "../../schemas/playlistSchema";
import { ItemTypes } from "../../constants";

const DraggablePlaylist = ({
  playlist,
  getDragItem,
}: {
  playlist: Playlist;
  // Returns the drag payload for this playlist. Lets the parent ship the
  // whole multi-selection when a selected item is dragged. Defaults to just
  // this playlist when not provided.
  getDragItem?: (playlist: Playlist) => any;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: ItemTypes.PLAYLIST,
    item: () => (getDragItem ? getDragItem(playlist) : { items: [playlist] }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  // Hide the default HTML5 drag ghost so CustomDragLayer renders the preview
  // (with a multi-item count badge) instead.
  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  drag(ref);

  return (
    <div
      ref={ref}
      className="flex flex-col items-center p-3 border bg-white shadow-sm rounded-lg cursor-move hover:shadow-md transition-shadow"
      style={{ opacity: isDragging ? 0.5 : 1 }}
      title={playlist.name}
    >
      <img
        src="assets/images/playlist-icon.jpg"
        className="h-20 w-20 text-primary-default mb-1"
        alt={playlist.name}
      />
      <span className="text-sm text-gray-700 font-medium text-center truncate w-full">
        {playlist.name}
      </span>
    </div>
  );
};

export default DraggablePlaylist;
